import React, {useEffect} from 'react';
import axios from "axios";
import MesureStore from "../../MesureStore";
import useDebounce from "../../../../Shared/Hooks";
import {loading, RequestState} from "../../../../Shared/StateHelper";
import {observer, Observer} from "mobx-react";
import {t} from "../../../../I18n/i18n"
import SmartTextArea from "../../../../Shared/UiKit/SmartTextArea";
import useDebounceV2 from "../../../../Hooks/useDebounceV2";

const EditPatientHistory = observer((props) => {

    useEffect(() => {
        if(MesureStore.mesureSaving) props.loading()
        else props.loaded()
    }, [MesureStore.mesureSaving]);

    return <div style={{display: "flex", flexDirection: "column", gap: 10}}>
        <SmartTextArea value={MesureStore.patient.history ?? ""} onChange={(e) => MesureStore.setHistory(e.target.value ?? "")}
                       style={{resize: "none", padding: 10, height: 120, fontSize: 12}}
                       placeholder={t("BACKGROUND")} shortcuts={MesureStore.textual_shortcuts}
        />
    </div>

})

export default EditPatientHistory;